import { DialogTitle } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { paperMaterialBusiness } from "api/bussiness/paper-material/paper-material-bussiness";
import { invalidatePaperCatalogCache } from "api/cached";
import { PaperTypeEnum } from "commons/enum/paper-type";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { observer } from "mobx-react-lite";
import { IAddPaperMaterial } from "mobx-stores/_models/paper-inventory/paper-material";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DialogComplexContent } from "share-components/templates/form/dialog-complex-form/dialog-complex-content";
import { DialogComplexFormContainer } from "share-components/templates/form/dialog-complex-form/dialog-complex-form";
import { DialogForm } from "share-components/templates/form/dialog-form";
import {
  getPaperSpecificationTypeOptionLabel,
  getPaperTypeOptionLabel,
} from "../share";
import { getAddPaperMaterialSchema } from "./schema";

export const AddPaperMaterial = observer(() => {
  const queryClient = useQueryClient();
  const {
    paperMaterialStore: { openNew, getPapersMaterial, setProp },
  } = useStores();
  const {
    form: { controls, isValid },

    submitHandler,
  } = useForm<IAddPaperMaterial>(getAddPaperMaterialSchema(), {
    code: "",
    gsm: 0,
    specificationLength: 0,
    specificationSize: 0,
    specificationType: "",
    type: "",
    typeSelect: "",
    specificationTypeSelect: "",
  });

  const saveHandler = useCallback(
    async (data: IAddPaperMaterial) => {
      try {
        await paperMaterialBusiness.add(data);
        await invalidatePaperCatalogCache(queryClient);
        await getPapersMaterial();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getPapersMaterial, queryClient, setProp],
  );

  const handlePaperTypeSelectChanged = useCallback(
    (control: IControl) => {
      const typeCtr = controls.find((c) => c.name === "type");
      if (typeCtr) {
        if (control.value === PaperTypeEnum.Other) {
          typeCtr.setProp("disabled", false);
          typeCtr.setValueAndValidate("");
        } else {
          typeCtr.setProp("disabled", true);
          typeCtr.setValueAndValidate(getPaperTypeOptionLabel(control.value));
        }
      }
    },
    [controls],
  );

  const handlePaperSpecificationTypeChanged = useCallback(
    (control: IControl) => {
      const specificationTypeCtr = controls.find(
        (c) => c.name === "specificationType",
      );
      if (specificationTypeCtr) {
        if (control.value === PaperTypeEnum.Other) {
          specificationTypeCtr.setProp("disabled", false);
          specificationTypeCtr.setValueAndValidate("");
        } else {
          specificationTypeCtr.setProp("disabled", true);
          specificationTypeCtr.setValueAndValidate(
            getPaperSpecificationTypeOptionLabel(control.value),
          );
        }
      }
    },
    [controls],
  );

  const valuesChangedHandler = useCallback(
    (control: IControl) => {
      if (control.name === "typeSelect") {
        handlePaperTypeSelectChanged(control);
      }
      if (control.name === "specificationTypeSelect") {
        handlePaperSpecificationTypeChanged(control);
      }
    },
    [handlePaperSpecificationTypeChanged, handlePaperTypeSelectChanged],
  );

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm vật tư giấy</DialogTitle>
      <DialogComplexContent>
        <DialogComplexFormContainer>
          <DynamicForm
            controls={controls}
            onValueChanged={valuesChangedHandler}
          ></DynamicForm>
        </DialogComplexFormContainer>
      </DialogComplexContent>
    </DialogForm>
  );
});

